import styled, { css } from "styled-components";
import { colors } from "@streeteasy/design-system";
import actionElements from "@streeteasy/design-system/constants/actionElements";
import TextAction from "@streeteasy/design-system/text-action";

import { largeScreen } from "src/shared/constants/screenSizes";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 514px;

  ${({ isExpandedAreaSection, userIsRMC }) =>
    !isExpandedAreaSection &&
    css`
      flex-wrap: wrap;
      max-height: ${userIsRMC ? "300px" : "355px"};
    `};

  @media screen and (max-width: ${largeScreen}px) {
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    margin: 0 auto;
    padding: 0 0 10px 0;
    width: 240px;

    ${({ isExpandedAreaSection }) =>
      !isExpandedAreaSection &&
      css`
        border: none;
        max-height: inherit;
      `};
  }
`;

export const LinksList = styled.ul`
  padding: 0 0 24px !important;

  @media screen and (max-width: ${largeScreen}px) {
    padding: 0 !important;
    text-align: center;

    ${({ isMWebHidden }) =>
      isMWebHidden &&
      css`
        display: none;
      `};
  }
`;

export const ListItem = styled.li`
  color: inherit;
  white-space: nowrap;

  @media screen and (max-width: ${largeScreen}px) {
    padding: 5px 0;
  }

  ${({ isHiddenDesktop }) =>
    isHiddenDesktop &&
    css`
      display: none;
      @media screen and (max-width: ${largeScreen}px) {
        display: block;
      }
    `};
  @media screen and (max-width: ${largeScreen}px) {
    ${({ isMWebHidden }) =>
      isMWebHidden &&
      css`
        display: none;
      `};
  }
`;

export const Link = styled(TextAction).attrs({
  element: actionElements.a
})`
  color: ${colors.WHITE};
  font-size: 12px;
  line-height: 24px;
  text-decoration: none !important;

  &:hover,
  &:active,
  &:focus {
    outline-color: ${colors.WHITE};
  }

  ${({ isSubLink }) =>
    !isSubLink &&
    css`
      font-weight: 700;
      letter-spacing: 0.05em;
      padding: 0;
      text-transform: uppercase;
    `};
`;
